import http from "../jslibs/axios/http";

// 案例分类列表
export const getCaseClass = (data) => http.get("/v1/cms/CaseClass", data);

// 新增案例分类
export const addCaseClass = (data) => http.post("/v1/cms/CaseClass", data);

// 删除案例分类
export const deleteCaseClass = (id) => http.delete(`/v1/cms/CaseClass/${id}`);

// 编辑案例分类
export const editCaseClass = (id, data) => http.put(`/v1/cms/CaseClass/${id}`, data);

// 案例分类详情
export const caseClassDetail = (id) => http.get(`/v1/cms/CaseClass/${id}`);

// 案例列表
export const getCaseInfo = (data) => http.get("/v1/cms/CaseInfo", data);

// 新增案例
export const addCaseInfo = (data) => http.post("/v1/cms/CaseInfo", data);

// 删除案例
export const deleteCaseInfo = (id) => http.delete(`/v1/cms/CaseInfo/${id}`);

// 编辑案例
export const editCaseInfo = (id, data) => http.put(`/v1/cms/CaseInfo/${id}`, data);

// 案例详情
export const caseInfoDetail = (id) => http.get(`/v1/cms/CaseInfo/${id}`);

// 设为推荐/取消推荐
export const caseRecommend = (id) => http.get(`/v1/cms/CaseRecommend/${id}`);
// 设为推荐/取消推荐
export const CaseSelected = (id) => http.get(`/v1/cms/CaseSelected/${id}`);

// 显示/隐藏
export const caseShow = (id) => http.get(`/v1/cms/CaseShow/${id}`);
// 热区列表
export const zoneList = () => http.get(`/v1/cms/HotArea`);
// 编辑热区
export const zoneEdit = (id,data) => http.put(`/v1/cms/HotArea/${id}`,data);
